import { CARD_RANKS } from '../../../constants/cards/cardRank'
import { BUSINESS_CARD_LABEL_NAME } from '../../../constants/cards/business'
const kindOfCards = [Object.keys(CARD_RANKS).map(key => CARD_RANKS[key].ID), BUSINESS_CARD_LABEL_NAME].flat()
const noResultView = document.querySelector('.sc21-CreditCardBenefitList-noResult')
const submitButton = document.querySelector('.sc21-CreditCardBenefitListForm-submit')
const categoryInputs = document.getElementsByName('category')
const benefitItems = document.getElementsByClassName('benefitFilterItem')
const cardTypeInputs = document.getElementsByName('type')
const contentsArea = document.querySelector('.sc21-CreditCardBenefitList-list')
cardTypeInputs.forEach(elm => elm.addEventListener('click', onChangeCardTypeInput))
submitButton.addEventListener('click', onClickSearchButton)
categoryInputs.forEach(elm => elm.addEventListener('change', onChangeCategoryInput))

let searchCategoryConditions = []
let searchCardTypeConditions = []
function onChangeCategoryInput(event) {
  event.target.checked
    ? searchCategoryConditions.push(event.target.value)
    : (searchCategoryConditions = searchCategoryConditions.filter(key => key !== event.target.value))
}
function onChangeCardTypeInput(event) {
  if (searchCardTypeConditions.includes(event.target.value)) {
    event.target.checked = false
    searchCardTypeConditions = searchCardTypeConditions.filter(tag => tag !== event.target.value)
  } else {
    searchCardTypeConditions = [
      searchCardTypeConditions.filter(tag => !kindOfCards.includes(tag)),
      event.target.value,
    ].flat()
  }
}

function onClickSearchButton() {
  scrollToTarget(contentsArea)
  Array.from(benefitItems).forEach(elm => {
    elm.style.display = 'none'
    const ranks = elm.dataset.ranks.split(',')
    const category = elm.dataset.categories.split(',')
    const isFullfilledRankCondition = searchCardTypeConditions.length
      ? ranks.includes(searchCardTypeConditions[0])
      : true
    const isFullfilledCategoryConditions = searchCategoryConditions.length
      ? searchCategoryConditions.some(inputValue => category.includes(inputValue))
      : true
    const isFullfilledConditions = isFullfilledRankCondition && isFullfilledCategoryConditions
    if (isFullfilledConditions) {
      fadeIn(elm, 'list-item')
    }
  })
  const isResultLength = [...benefitItems].every(elm => elm.style.display === 'none')
  isResultLength ? (noResultView.style.display = 'block') : (noResultView.style.display = 'none')
}

function fadeIn(el, display) {
  el.style.opacity = 0
  el.style.display = display || 'block'
  ;(function fade() {
    let val = parseFloat(el.style.opacity)
    if (!((val += 0.1) > 1)) {
      el.style.opacity = val
      requestAnimationFrame(fade)
    }
  })()
}

function scrollToTarget(target) {
  const targetPosition = target.getBoundingClientRect().top
  const offset = window.pageYOffset
  window.scrollTo({
    top: offset + targetPosition,
    behavior: 'smooth',
  })
}
